import { SUPPORTED_SELLER_LANGUAGES, getSellerLanguageNativeName } from '@fiverr-private/localization';
import { getContext } from '@fiverr-private/fiverr_context';

export const getLanguagesList = () => {
    const { locale } = getContext();

    return SUPPORTED_SELLER_LANGUAGES.map((code) => ({
        value: code,
        native_name: getSellerLanguageNativeName(code),
        name: i18n.t(`languages.codes.${code}`, { $scope: locale })
    }));
};
